import React from 'react'
import { List, ListItem, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from '@mui/material'
import FoundationIcon from '@mui/icons-material/Foundation'
import GroupAddIcon from '@mui/icons-material/GroupAdd'
import ThreeDRotationIcon from '@mui/icons-material/ThreeDRotation'

const FooterCol4 = (props) => {
  return (
    <Paper sx={{m:1, p: 1,}}>
      <Typography component="h3" fontWeight={600} variant="h6">Business Services</Typography>
      <List>
        {/* About Us */}
        <ListItem disablePadding>
          <ListItemButton href="/business/">
            <ListItemIcon>
              <GroupAddIcon />
            </ListItemIcon>
            <ListItemText primary="Partner With Us" />
          </ListItemButton>
        </ListItem>
        {/* 360 Views */}
        <ListItem disablePadding>
          <ListItemButton href="/business/">
            <ListItemIcon>
              <ThreeDRotationIcon />
            </ListItemIcon>
            <ListItemText primary="360 Views" />
          </ListItemButton>
        </ListItem>
        {/* Working Drawings */}
        <ListItem disablePadding>
          <ListItemButton href="/business/">
            <ListItemIcon>
              <FoundationIcon />
            </ListItemIcon>
            <ListItemText primary="Working Drawings" />
          </ListItemButton>
        </ListItem>
      </List>
    </Paper>
  )
}

export default FooterCol4